//繧ｹ繧ｯ繝ｭ繝ｼ繝ｫ繧､繝吶Φ繝磯未騾｣
//---------------------------------------------------------------
$(function () {
   // 莉雁屓縺ｮ莠､蟾ｮ繧堤屮隕悶☆繧玖ｦ∫ｴ�
   const boxes = document.querySelectorAll(".js-scroll");
   // viewport 50%縺ｮ菴咲ｽｮ縺ｧ逋ｺ轣ｫ
   const options = {
      root: null,
      rootMargin: "-10% 0px",
      threshold: 0,
   };
   const observer = new IntersectionObserver(doWhenIntersect, options);
   // 縺昴ｌ縺槭ｌ縺ｮbox繧堤屮隕悶☆繧�
   boxes.forEach((box) => {
      observer.observe(box);
   });
   function doWhenIntersect(entries) {
      // 莠､蟾ｮ讀懃衍繧偵＠縺溘ｂ縺ｮ縺ｮ縺ｪ縺九〒縲（sIntersecting縺荊rue縺ｮDOM繧帝未謨ｰ縺ｫ貂｡縺�
      entries.forEach((entry) => {
         if (entry.isIntersecting) {
            activateIndex(entry.target);
         }
      });
   }
   function activateIndex(element) {
      element.classList.add("is-active");

      // if(element.classList.contains('js-vivus')){
      //    const vivusObject = new Vivus(element, {
      //       duration: 150,
      //       type: 'delayed',
      //       file: '../img/top/bg_wave.svg',
      //       animTimingFunction: Vivus.EASE_OUT
      //    });
      // }
   }
});